import React from 'react';
import styles from './styles.module.scss';
import FileActionsPopper from './FileActionsPopper';
import { fileDownload } from 'helpers/AppHelpers';
import UploadFileButton from 'components/UploadFileButton/UploadFileButton';

export default function FileCellContent({ row = {}, onUploadFile, onDeleteFile, isEditable }) {
  const { resource = {} } = row;

  const downloadFile = (asset) => fileDownload(asset.resource);

  const uploadFile = (_, file) => onUploadFile({ ...row, resource: file });

  return (
    <div className={styles.file__actions}>
      {resource?.id ? (
        <FileActionsPopper
          asset={row}
          onDelete={onDeleteFile}
          onDownload={downloadFile}
          isEditable={isEditable}
        />
      ) : (
        <>{isEditable && <UploadFileButton onUploadFile={uploadFile} picklistAsset={row} />}</>
      )}
    </div>
  );
}
